webpackJsonp([35783957827783],{

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n  min-height: 300px;\n'], ['\n  position: relative;\n  min-height: 300px;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: -1;\n  min-height: 300px;\n  height: auto;\n  @media (min-width: ', ') {\n    height: ', ';\n  }\n  & > img {\n    object-fit: ', ' !important;\n    object-position: ', ' !important;\n  }\n  &::before {\n    content: \'\';\n    background: linear-gradient(\n      90deg,\n      rgba(28, 178, 191, 0.45),\n      rgba(130, 245, 255, 0.3)\n    );\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 100%;\n    width: 100%;\n    z-index: 1;\n  }\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: -1;\n  min-height: 300px;\n  height: auto;\n  @media (min-width: ', ') {\n    height: ', ';\n  }\n  & > img {\n    object-fit: ', ' !important;\n    object-position: ', ' !important;\n  }\n  &::before {\n    content: \'\';\n    background: linear-gradient(\n      90deg,\n      rgba(28, 178, 191, 0.45),\n      rgba(130, 245, 255, 0.3)\n    );\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 100%;\n    width: 100%;\n    z-index: 1;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  font-size: 2.4em;\n  line-height: 1.3;\n  text-transform: capitalize;\n  font-weight: 600;\n  position: absolute;\n  width: 100%;\n  max-width: ', ';\n  padding: 0 1rem;\n  top: 50%;\n  z-index: 10;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: white;\n  text-shadow: -1px 2px 2px rgba(0, 0, 0, 0.2);\n'], ['\n  font-size: 2.4em;\n  line-height: 1.3;\n  text-transform: capitalize;\n  font-weight: 600;\n  position: absolute;\n  width: 100%;\n  max-width: ', ';\n  padding: 0 1rem;\n  top: 50%;\n  z-index: 10;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: white;\n  text-shadow: -1px 2px 2px rgba(0, 0, 0, 0.2);\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(112);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.section(_templateObject);
	var BgImg = (0, _styledComponents2.default)(_gatsbyImage2.default)(_templateObject2, function (props) {
	  return props.theme.responsive.small;
	}, function (props) {
	  return props.height || 'auto';
	}, function (props) {
	  return props.fit || 'cover';
	}, function (props) {
	  return props.position || '50% 50%';
	});
	
	var Title = _styledComponents2.default.h1(_templateObject3, function (props) {
	  return props.theme.sizes.maxWidthCentered;
	});
	
	var Hero = function Hero(props) {
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(BgImg, {
	      height: props.height,
	      sizes: props.image.sizes,
	      backgroundColor: '#eeeeee'
	    }),
	    _react2.default.createElement(
	      Title,
	      null,
	      props.title
	    )
	  );
	};
	
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__(69);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _SEO = __webpack_require__(100);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _Hero = __webpack_require__(70);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _PageBody = __webpack_require__(99);
	
	var _PageBody2 = _interopRequireDefault(_PageBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Index = function Index(_ref) {
	  var data = _ref.data;
	
	  var page = data.page.edges[0];
	  var topContent = page.node.topContent;
	  var title = page.node.heading;
	  var bottomContent = page.node.bottomContent;
	  var heroImage = page.node.image;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_SEO2.default, null),
	    _react2.default.createElement(_Hero2.default, { title: title, image: heroImage, height: '40vh' }),
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(_PageBody2.default, { body: topContent }),
	      _react2.default.createElement(_PageBody2.default, { body: bottomContent })
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = Index;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-93a11baea9cc9cae7d6e.js